import type {ReactElement} from 'react'
// Components
import ClientText from '../client-text'
// Types
import type {BallotPageBlock} from '../../types/ballot'

interface RenderedTextBlockProps {
  block: BallotPageBlock
}

const RenderedTextBlock = ({block}: RenderedTextBlockProps): ReactElement | null => {
  const renderedText = block.formValuesObject.blockRenderedText

  if (!renderedText) return null

  return <ClientText clientText={renderedText} />
}

export default RenderedTextBlock
